<template>
    <div class="view-container">
        <!-- <h2>Tribute Slideshow</h2> -->

        <Slideshow
            @slide-duration="handleSlideDurationUpdate"
            autoPlay
            :intervalSeconds="tributeVideo?.webSlideshowSlideSeconds"
            :slides="slides"
        />

        <!-- <v-btn @click="setSlideDuration(6)">Set duration</v-btn> -->
    </div>
</template>

<script>
import Slideshow from '@/components/Tribute/Slideshow.vue';
import initApiServices from '@/services/ApiInitializer';
import { mapActions } from 'vuex';
import tributeVideo from '../../store/modules/tribute-video';
import { debounce } from 'lodash';

export default {
    name: 'TributeSlideshow',
    metaInfo() {
        let title = 'Tribute Slideshow';
        if (this.tributeVideo?.firstName && this.tributeVideo?.lastName) {
            title = `${this.tributeVideo.firstName} ${this.tributeVideo.lastName}'s Tribute Slides`;
        }
        return {
            title,
        };
    },
    data() {
        return {
            apiService: null,
            token: null,
            tributeVideo: null,
            slides: null,
            totalSlides: null,
        };
    },
    components: {
        Slideshow,
    },
    methods: {
        ...mapActions(['showSnackbar', 'block']),
        handleSlideDurationUpdate(val) {
            if (val && val != this.tributeVideo?.webSlideshowSlideSeconds) {
                this.setSlideDuration(val);
            }
        },
        async setAuthToken() {
            const response = await this.$auth.getIdTokenClaims();
            this.token = response.__raw;
        },
        async tryFetchTributeVideo(slug) {
            const resp = await this.apiService.tributeVideo.getTributeVideoByServiceSlug(slug);

            if (resp.data) {
                this.tributeVideo = resp.data.tributeVideo;
            }
        },
        async setSlideDuration(duration) {
            if (!this.tributeVideo?.id) {
                throw new Error('invalid tribute id');
            }

            const resp = await this.apiService.tributeVideo.setWebSlideshowSeconds(this.tributeVideo.id, duration);
        },
    },
    created() {
        this.debouncedHandleSlideDurationUpdate = debounce(this.handleSlideDurationUpdate, 400);
    },
    async mounted() {
        this.block(true);
        await this.setAuthToken();

        this.apiService = initApiServices(this.token);

        if (this.$route?.params?.slug) {
            await this.tryFetchTributeVideo(this.$route.params.slug);

            if (this.tributeVideo?.eventId) {
                const resp = await this.apiService.tributePhoto.getPhotos(this.tributeVideo?.eventId, {
                    reversed: false,
                    pageNumber: 0,
                    pageSize: this.tributeVideo?.totalSlidesCount ?? 999,
                });

                if (resp.data) {
                    this.slides = resp.data.photos;
                    this.totalSlides = resp.data.total;
                }
            }
        }
        this.block(false);
    },
};
</script>

<style lang="scss" scoped>
.view-container {
    width: calc(100vw - 8px);
    height: 100vh;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: black;
    overflow: hidden;
}
</style>
